var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCirclePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz48",
    d: "M97.05-850.9l14.15-14.15-2.3-2.25L97.05-855.45l-6-6L88.8-859.2ZM100-840a19.352,19.352,0,0,1-7.75-1.575,20.286,20.286,0,0,1-6.375-4.3,20.286,20.286,0,0,1-4.3-6.375A19.352,19.352,0,0,1,80-860a19.475,19.475,0,0,1,1.575-7.8,19.988,19.988,0,0,1,4.3-6.35,20.5,20.5,0,0,1,6.375-4.275A19.352,19.352,0,0,1,100-880a19.475,19.475,0,0,1,7.8,1.575,20.2,20.2,0,0,1,6.35,4.275,20.2,20.2,0,0,1,4.275,6.35A19.475,19.475,0,0,1,120-860a19.352,19.352,0,0,1-1.575,7.75,20.5,20.5,0,0,1-4.275,6.375,19.988,19.988,0,0,1-6.35,4.3A19.475,19.475,0,0,1,100-840Z",
    transform: "translate(-80 880)",
    fill: "#005a9e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirclePassword);
export default __webpack_public_path__ + "static/media/checkCirclePassword.350a33b48263833563a829d89e7d2d17.svg";
export { ForwardRef as ReactComponent };